// cart-restriction.js
document.addEventListener('DOMContentLoaded', function() {
  // カート状態の同期関数 - カートの実際の内容とセッションストレージを同期する
  async function syncCartState() {
    try {
      // カート情報を取得
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) {
        return;
      }
      
      const cart = await cartResponse.json();
      
      // カートが空の場合はセッションストレージをクリア
      if (!cart.items || cart.items.length === 0) {
        sessionStorage.removeItem('cart_has_delivery');
        sessionStorage.removeItem('cart_has_reservation');
        return;
      }
      
      // カート内のアイテムを分析
      let hasDelivery = false;
      let hasReservation = false;
      
      for (const item of cart.items) {
        if (item.properties && item.properties._tags) {
          const itemTags = item.properties._tags.split(',');
          if (itemTags.includes('配送商品')) hasDelivery = true;
          if (itemTags.includes('予約商品')) hasReservation = true;
        }
      }
      
      // セッションストレージを更新
      sessionStorage.setItem('cart_has_delivery', hasDelivery.toString());
      sessionStorage.setItem('cart_has_reservation', hasReservation.toString());
      
      return { hasDelivery, hasReservation };
    } catch (error) {
      return null;
    }
  }
  
  // ページ読み込み時に一度カート状態を同期
  syncCartState();
  
  // 商品がカートに追加される前に実行される関数
  async function validateCartBeforeAdd(event) {
    // ギフトオプション処理を優先
    if (window.isGiftOptionsProcessing === true) {
      console.log("ギフトオプション処理中のため、カート制限チェックをスキップします");
      return;
    }
    
    // カートに追加しようとしている商品のIDを取得
    const addToCartForm = event.target.closest('form[action*="/cart/add"]');
    if (!addToCartForm) return; // フォームが見つからない場合は処理を終了

    // フォームの送信をいったん防止
    event.preventDefault();
    
    try {
      // 現在のカート情報を取得
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) {
        addToCartForm.submit();
        return;
      }
      const cart = await cartResponse.json();
      
      // 追加しようとしている商品の情報を取得
      // 商品ページ上のmeta要素から商品タグを取得する
      const productTags = getProductTagsFromPage();
      const isDeliveryProduct = productTags.includes('配送商品');
      const isReservationProduct = productTags.includes('予約商品');
      
      // 現在のページが商品ページでない場合は制限を適用しない
      if (productTags.length === 0) {
        addToCartForm.submit();
        return;
      }
      
      // カート内の商品タグをチェック
      let cartHasDeliveryProducts = false;
      let cartHasReservationProducts = false;
      
      // カートが空でない場合
      if (cart.items && cart.items.length > 0) {
        // カート内の各商品のプロパティをチェック
        // 商品のプロパティにタグ情報が含まれている場合は、それを使用する
        for (const item of cart.items) {
          // カート内の商品のプロパティからタグ情報を確認
          // 一般的な方法として、商品をカートに追加する際にカスタムプロパティとしてタグ情報を追加する
          
          // 例: カートに商品を追加する際にカスタムプロパティとしてタグ情報を追加
          if (item.properties && item.properties._tags) {
            const itemTags = item.properties._tags.split(',');
            if (itemTags.includes('配送商品')) {
              cartHasDeliveryProducts = true;
            }
            if (itemTags.includes('予約商品')) {
              cartHasReservationProducts = true;
            }
          }
        }
      }
      
      // カート内の商品にタグがない場合は、セッションストレージから確認
      if (!cartHasDeliveryProducts && !cartHasReservationProducts) {
        cartHasDeliveryProducts = sessionStorage.getItem('cart_has_delivery') === 'true';
        cartHasReservationProducts = sessionStorage.getItem('cart_has_reservation') === 'true';
      }
      
      // 制約のチェック
      let canAddToCart = true;
      let errorMessage = '';
      
      if (isDeliveryProduct && cartHasReservationProducts) {
        canAddToCart = false;
        errorMessage = '予約商品がカートに入っている場合、配送商品を追加することはできません。';
      } else if (isReservationProduct && cartHasDeliveryProducts) {
        canAddToCart = false;
        errorMessage = '配送商品がカートに入っている場合、予約商品を追加することはできません。';
      }
      
      // 制約に引っかかった場合はエラーメッセージを表示
      if (!canAddToCart) {
        showErrorMessage(errorMessage);
        return; // 処理を終了
      }
      
      // カートに追加する商品のタグ情報をセッションストレージに保存
      if (isDeliveryProduct) {
        sessionStorage.setItem('cart_has_delivery', 'true');
      }
      if (isReservationProduct) {
        sessionStorage.setItem('cart_has_reservation', 'true');
      }
      
      // フォームにタグ情報を追加する（カート項目のプロパティとして保存するため）
      const tagsInput = document.createElement('input');
      tagsInput.type = 'hidden';
      tagsInput.name = 'properties[_tags]';
      tagsInput.value = productTags.join(',');
      addToCartForm.appendChild(tagsInput);
      
      // フォームのaction属性を保持
      const originalAction = addToCartForm.getAttribute('action');
      
      // ギフトオプションの有無を確認
      const hasGiftOptions = checkForGiftOptions();
      
      // ギフトオプションがある場合、ギフトオプションの処理に任せる
      if (hasGiftOptions && typeof window.handleCustomAddToCart === 'function') {
        window.handleCartRestrictionValidation = true;
        return;
      }
      
      // 制約に問題がなければ、通常通りカートに追加
      addToCartForm.submit();
      
    } catch (error) {
      // エラーが発生した場合は、通常通りカートに追加する
      addToCartForm.submit();
    }
  }
  
  // ギフトオプションの有無を確認する関数
  function checkForGiftOptions() {
    const addNoshiOption = document.getElementById('AddNoshiOption');
    const messageCardOption = document.querySelector('input[name="MessageCardOption"]:checked');
    const addBagOption = document.getElementById('AddBagOption');
    
    return (addNoshiOption && addNoshiOption.checked) || 
           (messageCardOption && messageCardOption.value !== 'なし') || 
           (addBagOption && addBagOption.checked);
  }
  
  // 商品ページからタグ情報を取得する関数
  function getProductTagsFromPage() {
    // 1. meta要素からタグ情報を取得する試み
    const metaTags = document.querySelector('meta[property="product:tag"]');
    if (metaTags && metaTags.content) {
      return metaTags.content.split(',').map(tag => tag.trim());
    }
    
    // 2. Shopifyの商品データがグローバル変数として利用可能か確認
    if (typeof meta !== 'undefined' && meta.product && meta.product.tags) {
      return Array.isArray(meta.product.tags) ? meta.product.tags : [meta.product.tags];
    }
    
    // 3. DOMから商品タグを探す（テーマによって実装が異なる場合があります）
    const tagElements = document.querySelectorAll('.product-tag, .product__tag, [data-product-tag]');
    if (tagElements.length > 0) {
      const tags = [];
      tagElements.forEach(el => {
        if (el.textContent) tags.push(el.textContent.trim());
      });
      return tags;
    }
    
    // 4. 特定のクラスを持つ要素からタグを取得（テーマ固有の実装）
    // このセレクタはテーマによって変更する必要があります
    const productTagsContainer = document.querySelector('.product-tags, .tags, .product-meta__tags');
    if (productTagsContainer) {
      const tagText = productTagsContainer.textContent.trim();
      if (tagText) {
        return tagText.split(',').map(tag => tag.trim());
      }
    }
    
    // 5. 現在のURLパスをチェックして商品タイプを判断（これはダミーロジックです）
    const path = window.location.pathname;
    if (path.includes('delivery') || path.includes('ship')) {
      return ['配送商品'];
    } else if (path.includes('reservation') || path.includes('booking')) {
      return ['予約商品'];
    }
    
    return [];
  }
  
  // エラーメッセージを表示する関数
  function showErrorMessage(message) {
    // 既存のエラーメッセージ要素があれば削除
    const existingError = document.getElementById('cart-error-message');
    if (existingError) {
      existingError.remove();
    }
    
    // エラーメッセージ要素を作成
    const errorDiv = document.createElement('div');
    errorDiv.id = 'cart-error-message';
    errorDiv.style.color = 'red';
    errorDiv.style.padding = '10px';
    errorDiv.style.marginTop = '10px';
    errorDiv.style.border = '1px solid red';
    errorDiv.style.borderRadius = '4px';
    errorDiv.style.backgroundColor = '#fff0f0';
    errorDiv.textContent = message;
    
    // フォームの後ろにエラーメッセージを挿入
    const addToCartForm = document.querySelector('form[action*="/cart/add"]');
    if (addToCartForm) {
      addToCartForm.after(errorDiv);
    } else {
      // フォームが見つからない場合は、bodyの先頭に追加
      document.body.prepend(errorDiv);
    }
  }
  
  // カートページでの初期化
  async function initCartPage() {
    try {
      // カートページでのみ実行
      if (!window.location.pathname.includes('/cart')) {
        return;
      }
      
      // カート情報を取得
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      
      // カートが空の場合
      if (!cart.items || cart.items.length === 0) {
        sessionStorage.removeItem('cart_has_delivery');
        sessionStorage.removeItem('cart_has_reservation');
        return;
      }
      
      // カート内の商品を分析し、タグ情報を更新
      let hasDelivery = false;
      let hasReservation = false;
      
      for (const item of cart.items) {
        if (item.properties && item.properties._tags) {
          const tags = item.properties._tags.split(',');
          if (tags.includes('配送商品')) hasDelivery = true;
          if (tags.includes('予約商品')) hasReservation = true;
        }
      }
      
      // セッションストレージを更新
      sessionStorage.setItem('cart_has_delivery', hasDelivery.toString());
      sessionStorage.setItem('cart_has_reservation', hasReservation.toString());
      
      // 矛盾するアイテムがある場合は警告を表示
      if (hasDelivery && hasReservation) {
        const warningDiv = document.createElement('div');
        warningDiv.style.color = 'red';
        warningDiv.style.padding = '10px';
        warningDiv.style.margin = '10px 0';
        warningDiv.style.border = '1px solid red';
        warningDiv.style.borderRadius = '4px';
        warningDiv.style.backgroundColor = '#fff0f0';
        warningDiv.textContent = '警告: カートに配送商品と予約商品が混在しています。同時に購入することはできません。';
        
        // カートの上部に警告を表示
        const cartForm = document.querySelector('form[action="/cart"]');
        if (cartForm) {
          cartForm.prepend(warningDiv);
        } else {
          document.querySelector('.cart, #cart, [data-cart]').prepend(warningDiv);
        }
        
        // チェックアウトボタンを無効化
        const checkoutButtons = document.querySelectorAll('[name="checkout"], .checkout-button, #checkout');
        checkoutButtons.forEach(button => {
          button.disabled = true;
          button.style.opacity = '0.5';
          button.title = '配送商品と予約商品は同時に購入できません';
        });
      }
    } catch (error) {
      // エラー処理
    }
  }
  
  // 削除ボタンへのイベントリスナーを追加
  function addRemoveButtonListeners() {
    // カートページでのみ実行
    if (!window.location.pathname.includes('/cart')) {
      return;
    }
    
    // 商品削除ボタン (テーマによってセレクタを調整する必要があるかもしれません)
    const removeButtons = document.querySelectorAll(
      'button[name="remove"], [href*="/cart/change"], .remove-button, .cart__remove-button, [data-cart-remove]'
    );
    
    if (removeButtons.length > 0) {
      removeButtons.forEach(button => {
        button.addEventListener('click', function() {
          // 少し遅延させてカートの状態が更新された後に実行
          setTimeout(() => syncCartState(), 500);
        });
      });
    } else {
      // Ajaxカートの場合、削除ボタンが動的に生成される可能性があるため、
      // ドキュメント全体にイベントリスナーを追加
      document.addEventListener('click', function(event) {
        const target = event.target;
        
        // 削除ボタンかどうかをチェック (クラス名やデータ属性で判断)
        if (
          target.classList.contains('remove-button') || 
          target.classList.contains('cart__remove-button') ||
          target.hasAttribute('data-cart-remove') ||
          target.closest('[data-cart-remove]') ||
          (target.tagName === 'A' && target.href && target.href.includes('/cart/change'))
        ) {
          setTimeout(() => syncCartState(), 500);
        }
      });
    }
  }
  
  // 数量変更フィールドへのイベントリスナーを追加
  function addQuantityFieldListeners() {
    // カートページでのみ実行
    if (!window.location.pathname.includes('/cart')) {
      return;
    }
    
    // 数量フィールド (テーマによってセレクタを調整する必要があるかもしれません)
    const quantityInputs = document.querySelectorAll(
      'input[name="updates[]"], [name^="updates["], .cart-item__quantity-input, [data-quantity-input]'
    );
    
    if (quantityInputs.length > 0) {
      quantityInputs.forEach(input => {
        input.addEventListener('change', function() {
          // 少し遅延させてカートの状態が更新された後に実行
          setTimeout(() => syncCartState(), 500);
        });
      });
    }
  }
  
  // カート更新ボタンへのイベントリスナーを追加
  function addUpdateButtonListeners() {
    // カートページでのみ実行
    if (!window.location.pathname.includes('/cart')) {
      return;
    }
    
    // カート更新ボタン (テーマによってセレクタを調整する必要があるかもしれません)
    const updateButtons = document.querySelectorAll(
      'button[name="update"], input[name="update"], .cart__update, [data-cart-update]'
    );
    
    if (updateButtons.length > 0) {
      updateButtons.forEach(button => {
        button.addEventListener('click', function() {
          // 少し遅延させてカートの状態が更新された後に実行
          setTimeout(() => syncCartState(), 500);
        });
      });
    }
  }
  
  // カートの変更を監視
  function setupCartChangeObserver() {
    // カートページでのみ実行
    if (!window.location.pathname.includes('/cart')) {
      return;
    }
    
    // カートコンテナ要素を取得
    const cartContainer = document.querySelector('.cart, #cart, [data-cart], form[action="/cart"]');
    
    if (cartContainer) {
      // MutationObserverを使用してDOM変更を監視
      const observer = new MutationObserver(function(mutations) {
        // 少し遅延させてカートの状態が更新された後に実行
        setTimeout(() => syncCartState(), 500);
      });
      
      // 設定オプション: 子要素の変更と属性の変更を監視
      const config = { childList: true, subtree: true, attributes: true };
      
      // 監視を開始
      observer.observe(cartContainer, config);
    }
  }
  
  // カートページの場合、カートの変更を監視する関数を実行
  if (window.location.pathname.includes('/cart')) {
    addRemoveButtonListeners();
    addQuantityFieldListeners();
    addUpdateButtonListeners();
    setupCartChangeObserver();
  }
  
  // Ajaxカートの変更を監視するためのイベントリスナー
  document.addEventListener('cart:updated', function(event) {
    syncCartState();
  });
  
  // チェックアウトボタンがクリックされたときのイベントハンドラ
  function validateCartBeforeCheckout(event) {
    // チェックアウトボタンが押されたときに、カート内に相反するタグの商品がないか確認
    const hasDelivery = sessionStorage.getItem('cart_has_delivery') === 'true';
    const hasReservation = sessionStorage.getItem('cart_has_reservation') === 'true';
    
    if (hasDelivery && hasReservation) {
      event.preventDefault();
      showErrorMessage('配送商品と予約商品は同時に購入できません。カートを確認してください。');
      return false;
    }
    return true;
  }
  
  // グローバル関数として公開
  window.validateCartBeforeAdd = validateCartBeforeAdd;
  window.getProductTagsFromPage = getProductTagsFromPage;
  window.showErrorMessage = showErrorMessage;
  
  // カートに追加ボタンにイベントリスナーを追加
  const addToCartButtons = document.querySelectorAll('button[type="submit"][name="add"]');
  addToCartButtons.forEach(button => {
    button.addEventListener('click', validateCartBeforeAdd);
  });
  
  // チェックアウトボタンにイベントリスナーを追加
  const checkoutButtons = document.querySelectorAll('[name="checkout"], .checkout-button, #checkout');
  checkoutButtons.forEach(button => {
    button.addEventListener('click', validateCartBeforeCheckout);
  });
  
  // カートページの初期化
  initCartPage();
  
  // ギフトオプションとの統合
  // フォームの送信を捕捉する代わりに、ギフトオプション処理のコールバックとして動作するようにする
  if (typeof window.registerCartRestrictionCallback === 'function') {
    window.registerCartRestrictionCallback(validateCartBeforeAdd);
  }
  
  // フェッチの上書き: カートAPIへのリクエストをインターセプトして状態を更新
  const originalFetch = window.fetch;
  window.fetch = async function(resource, init) {
    const response = await originalFetch(resource, init);
    
    // レスポンスをクローンして、元のレスポンスを保持
    const responseClone = response.clone();
    
    // カート関連のリクエストの場合、カート状態を更新
    if (
      (typeof resource === 'string' && (
        resource.includes('/cart/add') || 
        resource.includes('/cart/update') || 
        resource.includes('/cart/change') ||
        resource.includes('/cart/clear')
      )) ||
      (resource.url && (
        resource.url.includes('/cart/add') || 
        resource.url.includes('/cart/update') || 
        resource.url.includes('/cart/change') ||
        resource.url.includes('/cart/clear')
      ))
    ) {
      // 少し遅延させてカートの状態が更新された後に実行
      setTimeout(() => syncCartState(), 500);
    }
    
    // 元のレスポンスを返す
    return responseClone;
  };
});